<template>
  <b-row>
    <b-col
      cols="12"
      sm="12"
      md="12"
      lg="2"
    >
      <div
        v-for="(opcao, index) in opcoes"
        :key="index"
      >
        <b-button
          v-if="verificarPermissao(opcao.action)"
          class="mb-1"
          block
          variant="gradient-primary"
          :to="opcao.route"
          exact
          :data-cy="opcao.route.name"
        >
          {{ $t(opcao.title) }}
        </b-button>
      </div>
    </b-col>
    <b-col
      cols="12"
      sm="12"
      md="12"
      lg="10"
    >
      <router-view />
    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BButton, BCard,
} from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BCard,
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      opcoes: [
        {
          title: 'Convênios',
          route: { name: 'convenioSettings' },
          action: 'ROLE_CONVENIO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Campos Adicionais',
          route: { name: 'camposAdicionaisSettings' },
          action: 'ROLE_CAMPO_ADICIONAL_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Conselhos',
          route: { name: 'conselhoSettings' },
          action: 'ROLE_CONSELHO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Doenças CID',
          route: { name: 'doencasCidSettings' },
          action: 'ROLE_DOENCA_CID_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Especialidades',
          route: { name: 'especialidadeSettings' },
          action: 'ROLE_ESPECIALIDADE_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Exames',
          route: { name: 'exameSettings' },
          action: 'ROLE_EXAME_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Feriados',
          route: { name: 'feriadoSettings' },
          action: 'ROLE_FERIADO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Grupos',
          route: { name: 'grupoSettings' },
          action: 'ROLE_GRUPO_PROCEDIMENTO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Procedimentos',
          route: { name: 'procedimentoSettings' },
          action: 'ROLE_PROCEDIMENTO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Profissionais',
          route: { name: 'profissionalAtendimentoSettings' },
          action: 'ROLE_PROFISSIONAL_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Situações Atendimento',
          route: { name: 'situacaoAtendimentoSettings' },
          action: 'ROLE_SITUACAO_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Status Odontograma',
          route: { name: 'statusOdontogramaSettings' },
          action: 'ROLE_ODONTOGRAMA_STATUS_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Tipos Atendimento',
          route: { name: 'tipoAtendimentoSettings' },
          action: 'ROLE_TIPO_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Unidades Atendimento',
          route: { name: 'unidadeAtendimentoSettings' },
          action: 'ROLE_UNIDADE_ATENDIMENTO_CONSULTAR',
          resource: 'ACL',
        },
        {
          title: 'Parametros',
          route: { name: 'parameterAttendance' },
          action: 'ROLE_PARAMETRO_ATEND_CONSULTAR',
          resource: 'ACL',
        },
      ],
      permissionUser: undefined,
    }
  },
  methods: {
  },
}
</script>
